import { FormInstance, Steps } from 'antd';
import React from 'react';
import { stepItems } from './constants/steps';

type FormSiderProps = {
  form: FormInstance;
  step: number;
  setStep: (step: number) => void;
};

export const FormSider = React.memo(
  ({ form, step, setStep }: FormSiderProps) => {
    const handleStepNavigation = (value: number) => {
      form
        .validateFields()
        .then(() => setStep(value))
        .catch((error) => {
          console.error(error);
        });
    };

    return (
      <Steps
        onChange={handleStepNavigation}
        size="small"
        progressDot
        current={step}
        direction="vertical"
        items={stepItems.map((item) => ({
          ...item,
          title: <span style={{ lineHeight: 'normal' }}>{item.title}</span>,
        }))}
      />
    );
  },
);
